// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, Container, Typography } from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
import useSettings from 'src/hooks/useSettings';
// components
import { Navigate } from 'react-router-dom';
import Page from '../../components/Page';
import LogoSiptel from 'src/assets/svgComponents/LogoSiptel';
import LinkedinLogo from 'src/assets/svgComponents/LinkedinLogo';
import FacebookLogo from 'src/assets/svgComponents/FacebookLogo';

// sections
import { LoginForm } from '../../sections/auth/login';
/* import LockResetIcon from '@mui/icons-material/LockReset';
import { useState } from 'react';
import RestartForm from 'src/sections/auth/login/RestartForm';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; */

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  width: '30vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { isAuthenticated } = useAuth();
  const { themeMode } = useSettings();
  /*   const [restartPass, setRestartPass] = useState(false); */
  const mdUp = useResponsive('up', 'md');

  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Page title="Login">
      <RootStyle>
        <Container
          sx={{
            width: '40vw',
          }}
          maxWidth="sm"
        >
          <ContentStyle>
            <Stack
              direction="column"
              alignItems="center"
              sx={{ margin: 'auto auto' }}
            >
              <LogoSiptel height={60} />

              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 2,
                }}
              >
                <Typography variant="h5" gutterBottom>
                  {
                    /* restartPass ? 'Restablecer Contraseña' :  */ ' Iniciar sesión'
                  }
                </Typography>
              </Box>
              {/*  {restartPass ? <RestartForm /> : <LoginForm />} */}
              <LoginForm />
              {/*  {restartPass ? (
                <Stack
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                  sx={{ marginTop: '1rem', cursor: 'pointer' }}
                  onClick={() => setRestartPass(false)}
                  direction="row"
                >
                  <ArrowBackIcon sx={{ width: '1.1rem' }} color="primary" />
                  <Typography
                    sx={{ textDecoration: 'underline' }}
                    color="primary"
                    variant="body1"
                    gutterBottom
                  >
                    Volver al inicio de sesión
                  </Typography>
                </Stack>
              ) : (
                <Stack
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                  sx={{ marginTop: '1rem', cursor: 'pointer' }}
                  onClick={() => setRestartPass(true)}
                  direction="row"
                >
                  <Typography variant="body1" gutterBottom>
                    ¿Olvidó su contraseña? RESTABLECER
                  </Typography>
                  <LockResetIcon sx={{ color: 'gray' }} />
                </Stack>
              )} */}
            </Stack>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  textAlign: 'center',
                  padding: '0.5rem',
                  fontWeight: 'bold',
                  fontSize: '0.8rem',
                }}
                variant="p"
                gutterBottom
              >
                Visitanos en nuestras redes:
              </Typography>
              <a
                href="https://www.siptelchile.cl/"
                target="_blank"
                rel="noreferrer noopener"
              >
                {/* <img
                  style={{ cursor: 'pointer' }}
                  width="25"
                  src="https://i.postimg.cc/wMVHxw5h/web.png"
                  alt="web"
                /> */}
              </a>

              <a
                href="https://www.facebook.com/people/Siptel-Chile/100076306446651/?mibextid=LQQJ4d"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FacebookLogo
                  style={{ cursor: 'pointer' }}
                  fill={themeMode === 'light' ? '#22366B' : 'white'}
                  width="20"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/siptel-chile/?originalSubdomain=cl"
                target="_blank"
                rel="noreferrer noopener"
              >
                <LinkedinLogo
                  style={{ cursor: 'pointer' }}
                  fill={themeMode === 'light' ? '#22366B' : 'white'}
                  width="20"
                />
              </a>
            </Box>
          </ContentStyle>
        </Container>
        {mdUp && (
          <div
            style={{
              height: '100vh',
              width: '70vw',
              padding: '0 5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              /* background: 'rgb(2,0,36)', */
              background:
                'linear-gradient(328deg, rgba(2,0,36,1) 0%, rgba(15,5,76,1) 0%, rgba(21,12,87,1) 35%, rgba(35,26,111,1) 100%)',
            }}
          >
            <img src="/assets/notebook_login.png" alt="notebbok" />
          </div>
        )}

        {/* 
        <div
            style={{
              height: '58vmin',
              width: '75vmin',
              backgroundImage: `url("/assets/notebook_img.png")`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
            }}
          >
          <LoginSvg height="100%" /> 
          </div>

         {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            <Image
              visibleByDefault
              disabledEffect
              src="/assets/illustrations/illustration_login.png"
              alt="login"
            />
          </SectionStyle> */}
      </RootStyle>
    </Page>
  );
}
